import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { deleteCoreDataSecurityMonitorByIdSlice } from './delete';
import { muteCoreDataSecurityMonitorsSlice } from './mute';
import { patchCoreDataSecurityMonitorByIdSlice } from './patch';
import { subscribeCoreDataSecurityMonitorByIdSlice } from './subscribe';

export const coreDataSecurityMonitorsByIdReducers = combineReducers({
	delete: deleteCoreDataSecurityMonitorByIdSlice.asyncReducers,
	mute: muteCoreDataSecurityMonitorsSlice.asyncReducers,
	patch: patchCoreDataSecurityMonitorByIdSlice.asyncReducers,
	subscribe: subscribeCoreDataSecurityMonitorByIdSlice.asyncReducers
});

export const coreDataSecurityMonitorsByIdWatchers = combineAllWatchers([
	deleteCoreDataSecurityMonitorByIdSlice.asyncWatchers,
	muteCoreDataSecurityMonitorsSlice.asyncWatchers,
	patchCoreDataSecurityMonitorByIdSlice.asyncWatchers,
	subscribeCoreDataSecurityMonitorByIdSlice.asyncWatchers
]);
